module.exports = __webpack_public_path__ + "static/media/greece-blocks-mp-bg.f4933584.png";